import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStep5 = (state) => state.get('step5');

const makeSelectStep5 = () => createSelector(
  selectStep5,
  (step5State) => ({
    dateOfEvent: mapWithDefault(step5State, () => step5State.getIn(['form', 'dateOfEvent']), ''),
    timeOfEvent: mapWithDefault(step5State, () => step5State.getIn(['form', 'timeOfEvent']), ''),
    country: mapWithDefault(step5State, () => step5State.getIn(['form', 'country']), ''),
    city: mapWithDefault(step5State, () => step5State.getIn(['form', 'city']), ''),
    storyEvent: mapWithDefault(step5State, () => step5State.getIn(['form', 'storyEvent']), ''),
    // totalAmount: mapWithDefault(step5State, () => step5State.getIn(['form', 'totalAmount']), ''),
    title: mapWithDefault(step5State, () => step5State.getIn(['form', 'title']), ''),
    firstName: mapWithDefault(step5State, () => step5State.getIn(['form', 'firstName']), ''),
    surName: mapWithDefault(step5State, () => step5State.getIn(['form', 'surName']), ''),
    dateOfBirth: mapWithDefault(step5State, () => step5State.getIn(['form', 'dateOfBirth']), ''),
    relationshipToYou: mapWithDefault(step5State, () => step5State.getIn(['form', 'relationshipToYou']), ''),
    dateYouFirstBecomeAware: mapWithDefault(step5State, () => step5State.getIn(['form', 'dateYouFirstBecomeAware']), ''),
    detailOfMedicalCondition: mapWithDefault(step5State, () => step5State.getIn(['form', 'detailOfMedicalCondition']), ''),
    dateBookedTrip: mapWithDefault(step5State, () => step5State.getIn(['form', 'dateBookedTrip']), ''),
    dateScheduledToDepart: mapWithDefault(step5State, () => step5State.getIn(['form', 'dateScheduledToDepart']), ''),
    dateOriginallyScheduled: mapWithDefault(step5State, () => step5State.getIn(['form', 'dateOriginallyScheduled']), ''),
    selectedBenefits: mapWithDefault(step5State, () => step5State.getIn(['form', 'selectedBenefits']), ''),
  })
);

const makeSelectCountryList = () =>
  createSelector(selectStep5, (step5State) => step5State.get('countryList'));

const makeSelectCityList = () =>
  createSelector(selectStep5, (step5State) => step5State.get('cityList'));

const makeSelectClaimTypeList = () =>
  createSelector(selectStep5, (step5State) =>
    mapWithDefault(step5State, () => step5State.get('claimTypeList'), []),
  );

export {
  makeSelectStep5,
  makeSelectCountryList,
  makeSelectCityList,
  makeSelectClaimTypeList,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step5/selectors.js